import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import s from "./PendingVerificationWrapper.module.scss";
import clsx from "clsx";
import useDocumentTitle from "../../../../../global components/PageTitle";
import BreadCrumb from "../../../../../global components/BreadCrumbs/BreadCrumbs";
import Separator from "../../../../../global components/Icons/Separator";
import UserAddSolid from "../../../../../global components/Icons/UserAddSolid";
function PendingVerificationWrapper() {
  useDocumentTitle("Number management | Pending verifiction");

  const location = useLocation();
  const pathName = location.pathname;
  const items = [
    {
      title: (
        <Link to="/dashboard/number-management" className={clsx(s.link)}>
          <UserAddSolid className={s.icon} /> Number Management
        </Link>
      ),
    },
  ];
  if (pathName === "/dashboard/number-management/pending-requests") {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(s.link, {
            [s.active]: pathName.includes("pending-requests"),
          })}
          to="/dashboard/number-management/pending-requests"
        >
          Pending requests{" "}
        </Link>
      ), // Added title text
    });
  }

  return (
    <div className={s.wrapper}>
      <div className={s.breadCrumb}>
        <BreadCrumb
          items={items}
          separator={<Separator height={11} width={6.67} fill="#9CA3AF" />}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default PendingVerificationWrapper;
